// exports ApplicationReportGroup - an immutable object 'enum'
// usage: import { ApplicationReportGroup } from '../../enums/ApplicationReportGroup';
const applicationReportGroups = {
    MRRReports: 1,
    RADVReports: 2,
    CommReports: 3
};
Object.freeze(applicationReportGroups);
export const ApplicationReportGroup = applicationReportGroups;